import React, {Component} from "react";
import {Alert, FormGroup, Row, Col, Modal, Button, Card, CardBody, Label} from "reactstrap";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import * as Yup from "yup";
import {ErrorMessage, Field, Form, Formik, FieldArray} from "formik";
import SelectField from "../../components/Common/SelectField";
import PropTypes from "prop-types";
import {invoiceDetail, invoiceSelect, invoiceUpdate} from "../../store/invoice/actions";
import FileViewer from "../../components/Common/FileViewer";

const invoiceDataDefault = {
  name: "", supplier_crn: "", supplier_tax_id: "", supplier_vat_id: "", customer_crn: "", customer_tax_id: "", customer_vat_id: "", delivery_date: "", create_date: "", due_date: "", total: "",
}

class InvoiceDetailModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      invoiceData: invoiceDataDefault, select: null, invoiceDataLoaded: false, loadingDetail: false, errorDetail: "", loadingSelect: false, errorSelect: "", loadingUpdate: false, errorUpdate: "",
    }
    this.onClose = this.onClose.bind(this)
    this.onBlurSupplierCrn = this.onBlurSupplierCrn.bind(this)
  }

  componentDidMount() {
    this.props.onInvoiceDetail({sign: this.props.invoiceData.sign, history: this.props.history});
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({
        invoiceData: this.props.responseDetail ? this.props.responseDetail.response.invoiceData : invoiceDataDefault,
        select: this.props.responseSelect ? this.props.responseSelect.response.select : null,
        invoiceDataLoaded: !!this.props.responseDetail,
        loadingDetail: this.props.loadingDetail,
        errorDetail: this.props.errorDetail,
        loadingSelect: this.props.loadingSelect,
        errorSelect: this.props.errorSelect,
        loadingUpdate: this.props.loadingUpdate,
        errorUpdate: this.props.errorUpdate,
      })

      if (this.state.select === null && this.props.responseDetail && this.props.responseDetail.response.invoiceData.supplier_crn && this.props.responseDetail.response.invoiceData.supplier_crn.length > 0) {
        this.props.onInvoiceSelect({
          section_id: this.props.invoiceData.sectionId, supplier_crn: this.props.responseDetail.response.invoiceData.supplier_crn, history: this.props.history
        })
      }

      if ((this.props.responseUpdate && this.props.responseUpdate.status === 0)) {
        this.onClose()
      }
    }
  }

  onClose = () => {
    this.props.togModal()
    this.props.refreshParent()
  }

  onBlurSupplierCrn = (e) => {
    if (e.target.value.length >= 3) {
      this.props.onInvoiceSelect({section_id: this.props.invoiceData.sectionId, supplier_crn: e.target.value, history: this.props.history});
    }
  }

  totalRowValidate = (values) => {
    let total = 0;

    values.transactions.forEach(transaction => {
      total += transaction.total;
    })

    if (Math.abs(parseFloat(values.total) - total) < 0.05) {
      return {}
    }

    return {background: "#FFF5F5"}
  }

  transactionRowValidate = (transaction) => {
    if (Math.abs((parseFloat(transaction.base) + parseFloat(transaction.vat)) - parseFloat(transaction.total)) < 0.05 && Math.abs(((parseFloat(transaction.vat) / parseFloat(transaction.base)) * 100) - parseFloat(transaction.vatRate.value)) < 0.05) {
      return {}
    }

    return {background: "#FFF5F5"}
  }

  render() {
    return (<React.Fragment>
      <Modal isOpen={true} toggle={this.onClose} className="xxl-modal" contentClassName="xxl-modal-content">
        <div className="modal-header">
          <h5 className="modal-title mt-0">
            Invoice Detail
          </h5>
          <button type="button" onClick={this.onClose} className="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <Card>
          <CardBody>
            <Row className="mb-2">
              <Col className="col-4" style={{"height": "85vh", "overflow": "scroll"}}>
                {this.state.invoiceDataLoaded && <Formik
                  initialValues={this.state.invoiceData}
                  validationSchema={Yup.object().shape({
                    name: Yup.string().required("Please Enter Name"),
                    supplier_crn: Yup.string().required("Please Enter Supplier Crn"),
                    supplier_tax_id: Yup.string().required("Please Enter Supplier Tax Id"),
                    supplier_vat_id: Yup.string().required("Please Enter Supplier Vat Id"),
                    customer_crn: Yup.string().required("Please Enter Customer Crn"),
                    customer_tax_id: Yup.string().required("Please Enter Customer Tax Id"),
                    customer_vat_id: Yup.string().required("Please Enter Customer Vat Id"),
                    delivery_date: Yup.date().required("Please Enter Delivery Date"),
                    create_date: Yup.date().required("Please Enter Create Date"),
                    due_date: Yup.date().required("Please Enter Due Date"),
                    total: Yup.number().required("Please Enter Total"),
                    transactions: Yup.array()
                      .of(Yup.object().shape({
                        base: Yup.number().typeError("Base must be a number").required("Please enter Base"),
                        vatRate: Yup.object().typeError("Choose a Vat Rate"),
                        vat: Yup.number().typeError("Vat must be a number").required("Please enter Vat"),
                        total: Yup.number().typeError("Total must be a number").required("Please enter Total"),
                        account: Yup.object().typeError("Choose an Account"),
                      }))
                  })}
                  onSubmit={values => {
                    let newValues = {
                      name: values.name,
                      supplier_crn: values.supplier_crn,
                      supplier_tax_id: values.supplier_tax_id,
                      supplier_vat_id: values.supplier_vat_id,
                      customer_crn: values.customer_crn,
                      customer_tax_id: values.customer_tax_id,
                      customer_vat_id: values.customer_vat_id,
                      delivery_date: values.delivery_date,
                      create_date: values.create_date,
                      due_date: values.due_date,
                      total: values.total,
                      transactions: [...values.transactions],
                    }
                    newValues = JSON.parse(JSON.stringify(newValues));
                    for (let i = 0; i < newValues.transactions.length; i++) {
                      newValues.transactions[i].vat_rate = newValues.transactions[i].vatRate.value
                      newValues.transactions[i].account = newValues.transactions[i].account.value
                      delete newValues.transactions[i].vatRate
                    }
                    this.props.onInvoiceUpdate({sign: this.props.invoiceData.sign, data: newValues, history: this.props.history});
                  }}
                >
                  {({errors, status, touched, values}) => (<Form>
                    <div className="modal-body">
                      <Row>
                        <Col lg="6" className="mb-1">
                          <FormGroup>
                            <Label htmlFor="name">
                              Number
                            </Label>
                            <Field
                              id="name"
                              name="name"
                              placeholder="Enter Number"
                              type="text"
                              className={"form-control" + (errors.name && touched.name ? " is-invalid" : "")}
                            />
                            <ErrorMessage
                              name="name"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="4" className="mb-1">
                          <FormGroup>
                            <Label htmlFor="supplier_crn">
                              Supplier Crn
                            </Label>
                            <Field
                              id="supplier_crn"
                              name="supplier_crn"
                              placeholder="Enter Supplier Crn"
                              type="text"
                              className={"form-control" + (errors.supplier_crn && touched.supplier_crn ? " is-invalid" : "")}
                              onBlur={this.onBlurSupplierCrn}
                            />
                            <ErrorMessage
                              name="supplier_crn"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="4" className="mb-1">
                          <FormGroup>
                            <Label htmlFor="supplier_tax_id">
                              Supplier Tax Id
                            </Label>
                            <Field
                              id="supplier_tax_id"
                              name="supplier_tax_id"
                              placeholder="Enter Supplier Tax Id"
                              type="text"
                              className={"form-control" + (errors.supplier_tax_id && touched.supplier_tax_id ? " is-invalid" : "")}
                            />
                            <ErrorMessage
                              name="supplier_tax_id"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="4" className="mb-1">
                          <FormGroup>
                            <Label htmlFor="supplier_vat_id">
                              Supplier Vat Id
                            </Label>
                            <Field
                              id="supplier_vat_id"
                              name="supplier_vat_id"
                              placeholder="Enter Supplier Vat Id"
                              type="text"
                              className={"form-control" + (errors.supplier_vat_id && touched.supplier_vat_id ? " is-invalid" : "")}
                            />
                            <ErrorMessage
                              name="supplier_vat_id"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="4" className="mb-1">
                          <FormGroup>
                            <Label htmlFor="customer_crn">
                              Customer Crn
                            </Label>
                            <Field
                              id="customer_crn"
                              name="customer_crn"
                              placeholder="Enter Customer Crn"
                              type="text"
                              className={"form-control" + (errors.customer_crn && touched.customer_crn ? " is-invalid" : "")}
                            />
                            <ErrorMessage
                              name="customer_crn"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="4" className="mb-1">
                          <FormGroup>
                            <Label htmlFor="customer_tax_id">
                              Customer Tax Id
                            </Label>
                            <Field
                              id="customer_tax_id"
                              name="customer_tax_id"
                              placeholder="Enter Customer Tax Id"
                              type="text"
                              className={"form-control" + (errors.customer_tax_id && touched.customer_tax_id ? " is-invalid" : "")}
                            />
                            <ErrorMessage
                              name="customer_tax_id"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="4" className="mb-1">
                          <FormGroup>
                            <Label htmlFor="customer_vat_id">
                              Customer Vat Id
                            </Label>
                            <Field
                              id="customer_vat_id"
                              name="customer_vat_id"
                              placeholder="Enter Customer Vat Id"
                              type="text"
                              className={"form-control" + (errors.customer_vat_id && touched.customer_vat_id ? " is-invalid" : "")}
                            />
                            <ErrorMessage
                              name="customer_vat_id"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="4" className="mb-1">
                          <FormGroup>
                            <Label htmlFor="delivery_date">
                              Delivery Date
                            </Label>
                            <Field
                              id="delivery_date"
                              name="delivery_date"
                              placeholder="Enter Delivery Date"
                              type="date"
                              className={"form-control" + (errors.delivery_date && touched.delivery_date ? " is-invalid" : "")}
                            />
                            <ErrorMessage
                              name="delivery_date"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="4" className="mb-1">
                          <FormGroup>
                            <Label htmlFor="create_date">
                              Create Date
                            </Label>
                            <Field
                              id="create_date"
                              name="create_date"
                              placeholder="Enter Create Date"
                              type="date"
                              className={"form-control" + (errors.create_date && touched.create_date ? " is-invalid" : "")}
                            />
                            <ErrorMessage
                              name="create_date"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="4" className="mb-1">
                          <FormGroup>
                            <Label htmlFor="due_date">
                              Due Date
                            </Label>
                            <Field
                              id="due_date"
                              name="due_date"
                              placeholder="Enter Due Date"
                              type="date"
                              className={"form-control" + (errors.due_date && touched.due_date ? " is-invalid" : "")}
                            />
                            <ErrorMessage
                              name="due_date"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row style={this.totalRowValidate(values)}>
                        <Col lg="6" className="mb-1">
                          <FormGroup>
                            <Label htmlFor="total">
                              Total
                            </Label>
                            <Field
                              id="total"
                              name="total"
                              placeholder="Enter Total"
                              type="number"
                              className={"form-control" + (errors.total && touched.total ? " is-invalid" : "")}
                            />
                            <ErrorMessage
                              name="total"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12" className="mb-1">
                          <hr/>
                        </Col>
                      </Row>
                      {this.state.select && this.state.select.vatRates && this.state.select.accounts && this.state.select.accounts.length > 0 && <FieldArray name="transactions">
                        {({insert, remove, push}) => {
                          return (<div>
                            {values.transactions && values.transactions.length > 0 && values.transactions.map((transaction, index) => {
                              return (<div key={index}>
                                <Row style={this.transactionRowValidate(transaction)}>
                                  <Col lg="3" className="mb-1">
                                    <FormGroup>
                                      <SelectField label="Vat Rate" name={`transactions.${index}.vatRate`} options={this.state.select.vatRates}/>
                                    </FormGroup>
                                  </Col>
                                  <Col lg="7" className="mb-1">
                                    <FormGroup>
                                      <SelectField label="Account" name={`transactions.${index}.account`}
                                                   options={this.state.select.accounts}/>
                                    </FormGroup>
                                  </Col>
                                  <Col lg="2" className="mb-1 text-end">
                                    <Button color="danger" onClick={() => remove(index)}>-</Button>
                                  </Col>
                                  <Col lg="4" className="mb-1">
                                    <FormGroup>
                                      <Label htmlFor={`transactions.${index}.base`}>
                                        Base
                                      </Label>
                                      <Field
                                        id={`transactions.${index}.base`}
                                        name={`transactions.${index}.base`}
                                        placeholder="Enter Base"
                                        type="number"
                                        className={"form-control" + (errors.transactions && errors.transactions[index] && errors.transactions[index].base && touched.transactions && touched.transactions[index] && touched.transactions[index].base ? " is-invalid" : "")}
                                      />
                                      <ErrorMessage
                                        name={`transactions.${index}.base`}
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </FormGroup>
                                  </Col>
                                  <Col lg="4" className="mb-1">
                                    <FormGroup>
                                      <Label htmlFor={`transactions.${index}.vat`}>
                                        Vat
                                      </Label>
                                      <Field
                                        id={`transactions.${index}.vat`}
                                        name={`transactions.${index}.vat`}
                                        placeholder="Enter Vat"
                                        type="number"
                                        className={"form-control" + (errors.transactions && errors.transactions[index] && errors.transactions[index].vat && touched.transactions && touched.transactions[index] && touched.transactions[index].vat ? " is-invalid" : "")}
                                      />
                                      <ErrorMessage
                                        name={`transactions.${index}.vat`}
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </FormGroup>
                                  </Col>
                                  <Col lg="4" className="mb-1">
                                    <FormGroup>
                                      <Label htmlFor={`transactions.${index}.total`}>
                                        Total
                                      </Label>
                                      <Field
                                        id={`transactions.${index}.total`}
                                        name={`transactions.${index}.total`}
                                        placeholder="Enter Total"
                                        type="number"
                                        className={"form-control" + (errors.transactions && errors.transactions[index] && errors.transactions[index].total && touched.transactions && touched.transactions[index] && touched.transactions[index].total ? " is-invalid" : "")}
                                      />
                                      <ErrorMessage
                                        name={`transactions.${index}.total`}
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col lg="12" className="mb-1">
                                    <FormGroup>
                                      <Label htmlFor={`transactions.${index}.description`}>
                                        Description
                                      </Label>
                                      <Field
                                        id={`transactions.${index}.description`}
                                        name={`transactions.${index}.description`}
                                        placeholder="Enter Description"
                                        type="text"
                                        className={"form-control" + (errors.transactions && errors.transactions[index] && errors.transactions[index].description && touched.transactions && touched.transactions[index] && touched.transactions[index].description ? " is-invalid" : "")}
                                      />
                                      <ErrorMessage
                                        name={`transactions.${index}.description`}
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </div>);
                            })}
                            <div className="me-auto">
                              <Button color="success" onClick={() => push({base: "", vatRate: this.state.select.vatRates[0], vat: "", total: "", account: this.state.select.accounts[0]})}
                                      className="m-1">+</Button>
                            </div>
                          </div>)
                        }}
                      </FieldArray>}
                      {(!this.state.select || !this.state.select.vatRates || !this.state.select.accounts || this.state.select.accounts.length === 0) && <Row>
                        <Col lg="12" className="mb-1">
                          No associated analytical accounts between supplier and customer.
                        </Col>
                      </Row>}
                    </div>
                    <div className="modal-footer">
                      {this.state.loadingUpdate && (<div className="spinner-border text-primary m-1 me-auto" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>)}
                      {this.state.errorUpdate.length > 0 && (<Alert color="danger" role="alert" className="me-auto">
                        {this.state.errorUpdate}
                      </Alert>)}
                      <Button color="primary" type="submit">
                        Save
                      </Button>
                    </div>
                  </Form>)}
                </Formik>}
              </Col>
              <Col className="col-8" style={{"height": "85vh", "overflow": "scroll"}}>
                <FileViewer sign={this.props.invoiceData.sign} name={this.props.invoiceData.name}/>
              </Col>
            </Row>
            {this.state.loadingDetail && (<div className="d-flex justify-content-center">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>)}
            {this.state.errorDetail.length > 0 && (<div className="mt-3">
              <Alert color="danger" role="alert">
                {this.state.errorDetail}
              </Alert>
            </div>)}
          </CardBody>
        </Card>
      </Modal>
    </React.Fragment>)
  }
}

InvoiceDetailModal.propTypes = {
  onInvoiceDetail: PropTypes.func, onInvoiceSelect: PropTypes.func, onInvoiceUpdate: PropTypes.func,
};

const mapStateToProps = ({Invoice}) => ({
  responseDetail: Invoice.responseDetail,
  loadingDetail: Invoice.loadingDetail,
  errorDetail: Invoice.errorDetail,
  responseSelect: Invoice.responseSelect,
  loadingSelect: Invoice.loadingSelect,
  errorSelect: Invoice.errorSelect,
  responseUpdate: Invoice.responseUpdate,
  loadingUpdate: Invoice.loadingUpdate,
  errorUpdate: Invoice.errorUpdate,
});

const mapDispatchToProps = dispatch => ({
  onInvoiceDetail: data => dispatch(invoiceDetail(data)), onInvoiceSelect: data => dispatch(invoiceSelect(data)), onInvoiceUpdate: data => dispatch(invoiceUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(InvoiceDetailModal));